import { useEffect, useState } from 'react'
import { axiosClient } from 'src/services/axiosInstance'
import type { GetKitlooksResponse } from 'src/types/kitlooks'

import { KitlookWidget } from './KitlookWidget'

interface KitlookCMSWrapperProps {
  productIds: string[]
}

export function KitlookCMSWrapper({ productIds }: KitlookCMSWrapperProps) {
  const [kitlookData, setKitlookData] = useState<GetKitlooksResponse | null>(
    null
  )

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axiosClient
        .post('/api/getKitlookInfo', {
          productIds,
        })
        .catch(() => ({ data: null }))

      if (!data) return

      setKitlookData(data.response)
    }

    fetchData()
  }, [productIds])

  if (!kitlookData) return null

  return (
    <KitlookWidget
      kitlooks={kitlookData.kits}
      productId={productIds.join('')}
    />
  )
}
